import { HttpClient } from 'common/services/http-client.service';
import { PagedRequest } from 'common/models/data/pagedRequest.model';
import syncHistoryConfig from './sync-history.config';

export class SyncHistoryService extends HttpClient {
    public static async fetchSyncLogsList(pagedRequest: PagedRequest) {
        return SyncHistoryService.invokeApi(syncHistoryConfig.getSyncHistoryUrl(pagedRequest));
    }
}
